// import 'whatwg-fetch';
import React from 'react';
import { createRoot } from 'react-dom/client';
import configureStore, { history } from './store/configureStore';
import Root from './components/Root';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'tablesaw/dist/tablesaw.css';
import 'primereact/resources/themes/lara-light-purple/theme.css';
import 'react-toggle/style.css';
import 'primeicons/primeicons.css';
import './styles/styles.scss';
require('./favicon.ico'); // Tell webpack to load favicon.ico
import './fonts/GreycliffCF-Regular.woff2';
import './fonts/GreycliffCF-Bold.woff2';
import './fonts/GreycliffCF-Medium.woff2';
import './styles/font-awesome-6/css/regular.css';
import './styles/font-awesome-6/css/brands.css';
import './styles/font-awesome-6/css/solid.css';
import './styles/font-awesome-6/css/light.css';
import './styles/font-awesome-6/css/fontawesome.css';

const { store, persistor } = configureStore();
window.confettiCount = 0;

const container = document.getElementById('app');
const root = createRoot(container);

const renderApp = () => {
	root.render(
		<Root store={store} history={history} persistor={persistor} />
	);
};

renderApp();

// Enable hot module replacement for React components
if (module.hot) {
	module.hot.accept('./components/Root', () => {
		renderApp();
	});
}

// Make the FA lib wrap svg icons so that later removal of an icon elem from the dom doesn't crash the app
// window['FontAwesome'].config['autoReplaceSvg'] = 'nest';